import Accordion from '../components/accordion';
import AddToCartMsg from './addToCartMsg';
import EnhancedSeo from '../enhancedSeo';
import carousel from '../components/carousel';
import {showAlertModal} from './giftCardHelper';
import Callout from '../components/callout';

/**
 * Retrieves the relevant pid value
 * @param {jquery} $el - DOM container for a given add to cart button
 * @return {string} - value to be used when adding product to cart
 */
function getPidValue($el) {
  var pid;

  if ($('#quickViewModal').hasClass('show') && !$('.product-set').length) {
    pid = $($el).closest('.modal-content').find('.product-quickview').data('pid');
  } else if ($('.product-set-detail').length) {
    pid = $($el).closest('.product-detail').find('.product-id').text();
  } else if ($($el).closest('.product-detail').length === 0) {
    pid = $($el).attr('data-pid');
  } else {
    pid = $($el).closest('.product-detail:not(".bundle-item")').attr('data-pid');
  }

  return pid;
}

/**
 * Retrieve contextual quantity selector
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {jquery} - quantity selector DOM container
 */
function getQuantitySelector($el) {
  return $el && $('.set-items').length ? $($el).closest('.product-detail').find('.quantity-select') : $('.quantity-select');
}

/**
 * Retrieves the value associated with the Quantity pull-down menu
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {string} - value found in the quantity input
 */
function getQuantitySelected($el) {
  return getQuantitySelector($el).val();
}

/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function processSwatchValues(attr, $productContainer) {
  attr.values.forEach(function (attrValue) {
    var $attrValue = $productContainer.find('[data-attr="' + attr.id + '"] [data-attr-value="' + attrValue.value + '"]');
    var $swatchAnchor = $attrValue;

    if (attrValue.selected) {
      $attrValue.addClass('selected');
    } else {
      $attrValue.removeClass('selected');
    }

    if (attrValue.url) {
      $swatchAnchor.attr('href', attrValue.url);
      $attrValue.attr('data-image-url', attrValue.imageUrl).removeAttr('disabled');
      $attrValue.attr('data-modal-image-url', attrValue.imageModalUrl).removeAttr('disabled');
      $attrValue.attr('data-accordion-url', attrValue.accordionUrl).removeAttr('disabled');
    } else {
      $swatchAnchor.removeAttr('href');
    }

    // Disable if not selectable
    $attrValue.removeClass('selectable unselectable');
    $attrValue.addClass(attrValue.selectable ? 'selectable' : 'unselectable');
  });
}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be selected. If there is no variant that corresponds to a specific combination of attribute values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function processNonSwatchValues(attr, $productContainer) {
  var $attr = '[data-attr="' + attr.id + '"]';

  attr.values.forEach(function (attrValue) {
    var $attrValue = $productContainer.find($attr + ' [data-attr-value="' + attrValue.value + '"]');
    $attrValue.attr('data-url-value', attrValue.url).removeAttr('disabled');
    $attrValue.attr('data-accordion-url', attrValue.accordionUrl).removeAttr('disabled');
    if (!attrValue.selectable) {
      $attrValue.attr('disabled', true);
    }

    if (attrValue.selected) {
      $attrValue.addClass('selected');
    } else {
      $attrValue.removeClass('selected');
    }
  });
}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be selected. If there is no variant that corresponds to a specific combination of attribute values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function processNonSwatchValuesMiniSet(attr, $productContainer) {
  let $attr = $productContainer.find($('.list-' + attr.id));

  attr.values.forEach(function (attrValue) {
    let $attrValue = $attr.find('[data-attr-value="' + attrValue.value + '"]');

    $attrValue.attr('value', attrValue.url).removeAttr('disabled');

    if (!attrValue.selectable) {
      $attrValue.attr('disabled', true);
    }

    if (attrValue.selected) {
      $attrValue.attr('selected', 'selected');
      $attrValue.addClass('selected');
    } else {
      $attrValue.removeAttr('selected');
      $attrValue.removeClass('selected');
    }
  });
}

/**
 * Routes the handling of attribute processing depending on whether the attribute has image
 *     swatches or not
 *
 * @param {Object} attrs - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAttrs(attrs, $productContainer) {
  const attrsWithSwatches = ['color'];

  attrs.forEach(function (attr) {
    if (attrsWithSwatches.indexOf(attr.id) > -1) {
      processSwatchValues(attr, $productContainer);
    } else {
      processNonSwatchValues(attr, $productContainer);
    }
  });
}

/**
 * Routes the handling of attribute processing depending on whether the attribute has image swatches or not
 *
 * @param {Object} attrs - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateMiniAttrs(attrs, $productContainer) {
  const attrsWithSwatches = ['color'];

  attrs.forEach(function (attr) {
    if (attrsWithSwatches.indexOf(attr.id) > -1) {
      processSwatchValues(attr, $productContainer);
    } else {
      processNonSwatchValuesMiniSet(attr, $productContainer);
    }
  });
}

/**
 * Updates the availability status in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAvailability(response, $productContainer) {
  var availabilityValue = '';
  var availabilityMessages = response.product.availability.messages;
  if (!response.product.readyToOrder) {
    availabilityValue = '<div>' + response.resources.info_selectforstock + '</div>';
  } else {
    availabilityMessages.forEach(function (message) {
      availabilityValue += '<div>' + message + '</div>';
    });
    controlSizeModalProduct(null, response);
  }

  /** Controllo che mostra la label del prodotto in quick view solo se la label del prodotto è presente */
  var $nameGroup = $('.product-name-group');
  var $labels = $('.product-tag-labels');
  var label = response.product.label;

  if ($labels.length === 0 && label) {
    $nameGroup.prepend('<ul class="product-tag-labels"><li><span class="product-tag-label">' + label + '</span></li></ul>');
  } else if ($labels.length > 0 && label) {
    $labels.find('span').text(label);
    $labels.removeClass('hide');
  } else if (!label && $labels.length > 0) {
    $labels.addClass('hide');
  }

  $($productContainer).trigger('product:updateAvailability', {
    product: response.product,
    $productContainer: $productContainer,
    message: availabilityValue,
    resources: response.resources
  });
}

/**
 * Generates html for promotions section
 *
 * @param {array} promotions - list of promotions
 * @return {string} - Compiled HTML
 */
function getPromotionsHtml(promotions) {
  if (!promotions) {
    return '';
  }

  var html = '';

  promotions.forEach(function (promotion) {
    html += '<div class="callout-msg">' + promotion.calloutMsg + '</div>';
  });

  return html;
}

/**
 * Generates html for product attributes section
 *
 * @param {array} attributes - list of attributes
 * @return {string} - Compiled HTML
 */
function getAttributesHtml(attributes) {
  if (!attributes) {
    return '';
  }

  var html = '';

  attributes.forEach(function (attributeGroup) {
    if (attributeGroup.ID === 'mainAttributes') {
      attributeGroup.attributes.forEach(function (attribute) {
        html += '<div class="attribute-values">' + attribute.label + ': '
            + attribute.value + '</div>';
      });
    }
  });

  return html;
}

/**
 * @typedef UpdatedOptionValue
 * @type Object
 * @property {string} id - Option value ID for look up
 * @property {string} url - Updated option value selection URL
 */

/**
 * @typedef OptionSelectionResponse
 * @type Object
 * @property {string} priceHtml - Updated price HTML code
 * @property {Object} options - Updated Options
 * @property {string} options.id - Option ID
 * @property {UpdatedOptionValue[]} options.values - Option values
 */

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
function handleVariantResponse(response, $productContainer) {
  let isChoiceOfBonusProducts = $productContainer.parents('.choose-bonus-product-dialog').length > 0;
  let isVaraint;
  let isNewtest = response.product.isNewtest;
  let isInWishlist = response.product.isInWishlist;
  let isOnSale = response.product.isSale;

  if (response.product.variationAttributes) {
    updateAttrs(response.product.variationAttributes, $productContainer);
    isVaraint = response.product.productType === 'variant';
    if (isChoiceOfBonusProducts && isVaraint) {
      $productContainer.parent('.bonus-product-item').data('pid', response.product.id);
      $productContainer.parent('.bonus-product-item').data('ready-to-order', response.product.readyToOrder);
    }
  }

  if (!isChoiceOfBonusProducts) {
    var $priceSelector = $('.product-name-group .price');
    $priceSelector.replaceWith(response.product.price.html);
  }

  $('.side-details .product-name').empty().html(response.product.productName);
  $('.promotions').empty().html(getPromotionsHtml(response.product.promotions));

  updateAvailability(response, $productContainer);

  if (isChoiceOfBonusProducts) {
    var $selectButton = $productContainer.find('.select-bonus-product');
    $selectButton.trigger('bonusproduct:updateSelectButton', {
      product: response.product,
      $productContainer: $productContainer
    });
  } else {
    $('button.add-to-cart, button.add-to-cart-global').trigger('product:updateAddToCart', {
      product: response.product,
      $productContainer: $productContainer
    }).trigger('product:statusUpdate', response.product);
  }

  if (isNewtest) {
    $('.side-details .new-arrival').addClass('show').removeClass('hide');
  } else {
    $('.side-details .new-arrival').addClass('hide').removeClass('show');
  }

  if (isOnSale) {
    $('.side-details .is-sale').addClass('show').removeClass('hide');
  } else {
    $('.side-details .is-sale').addClass('hide').removeClass('show');
  }

  if (isInWishlist) {
    $('.side-details .add-to-wish-list, .side-grid-images .add-to-wish-list').addClass('is-in-wishlist');
  } else {
    $('.side-details .add-to-wish-list, .side-grid-images .add-to-wish-list').removeClass('is-in-wishlist');
  }

  if ($productContainer.find('.error-msg').length) {
    $productContainer.find('.error-msg').remove();
  }

  $productContainer.find('.add-to-wish-list').each(function (index, el) {
    el = $(el);
    el.attr('disabled', false);
    const attr = el.attr('data-remove-url');

    if (typeof attr !== typeof undefined && attr !== false) {
      el.attr('data-remove-url', el.attr('data-remove-url').replace(/\?pid=.*/g, '?pid=' + response.product.id));
    }
  });

  $productContainer.find('.main-attributes').empty().html(getAttributesHtml(response.product.attributes));
  $productContainer.removeClass('loading');
}

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected on a mini product set.
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
function handleVariantMiniSetResponse(response, $productContainer) {
  if (response.product.variationAttributes) {
    updateMiniAttrs(response.product.variationAttributes, $productContainer);
  }

  var $priceSelector = $productContainer.find('.price');
  $priceSelector.replaceWith(response.product.price.html);

  $productContainer.find('.product-info .product-link').text(response.product.productName);
  $productContainer.find('button.add-to-cart-set').trigger('product:updateAddToCartMiniSet', {
    product: response.product,
    $productContainer: $productContainer
  });

  $productContainer.removeClass('loading');
}

/**
 * @typespec UpdatedQuantity
 * @type Object
 * @property {boolean} selected - Whether the quantity has been selected
 * @property {string} value - The number of products to purchase
 * @property {string} url - Compiled URL that specifies variation attributes, product ID, options, etc.
 */

/**
 * Updates the quantity DOM elements post Ajax call
 * @param {UpdatedQuantity[]} quantities -
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function updateQuantities(quantities, $productContainer) {
  if (!($productContainer.parent('.bonus-product-item').length > 0)) {
    var optionsHtml = quantities.map(function (quantity) {
      var selected = quantity.selected ? ' selected ' : '';
      return '<option value="' + quantity.value + '"  data-url="' + quantity.url + '"' + selected + '>' + quantity.value + '</option>';
    }).join('');
    getQuantitySelector($productContainer).empty().html(optionsHtml);
  }
}

/**
 * Updates the "color name" DOM element post Ajax call
 */
function updateColorName() {
  if ($('.color-cell-container').find('.swatch-color').hasClass('selected')) {
    var colorName = $('.swatch-color.selected').attr('data-display-value');
    $('[data-attr="color"]').find('.color-name').text(colorName);
  } else {
    $('[data-attr="color"]').find('.color-name').text('');
  }
}

function updateColorNameModal(){
  $('.modal-content').each(function() {
    var $modal = $(this);
    var $colorContainer = $modal.find('.color-cell-container');
    var $selectedColor = $colorContainer.find('.swatch-color.selected');
    var $colorNameElement = $modal.find('[data-attr="color"] .color-name');

    if ($selectedColor.length) {
      var colorName = $selectedColor.attr('data-display-value');
      $colorNameElement.text(colorName);
    } else {
      $colorNameElement.text('');
    }
  })
}
/**
 * updates the product view when a product attribute is selected or deselected or when changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 */
function attributeSelect(selectedValueUrl, $productContainer, $secondaryCall) {
  if (typeof $secondaryCall === 'undefined') {
    $secondaryCall = false;
  }

  if (selectedValueUrl) {
    $.ajax({
      url: selectedValueUrl,
      method: 'GET',
      beforeSend: function () {
        $productContainer.addClass('loading');
      },
      success: function (data) {
        handleVariantResponse(data, $productContainer);
        updateQuantities(data.product.quantities, $productContainer);
        updateColorName();
        updateColorNameModal();
        updateAddToCartEvent(data.product);
        updateLabel(data.product);
        controlSizeModalProduct(null, ($productContainer.hasClass('product-quickview')) ? data : null);
        if (!$secondaryCall) {
          replaceProductsetWidget(data);
          updateScalapayWidget(data.product);
          //Aggiunta una chiamata Ajax al controller Product-CompleteYourLook che ritorna tutto il template processato complete your look e rimpiazza
          var completeYourLookWrapper =  $('.complete-your-look-wrapper');
          //ho notato questa funzione (attributeSelect) è chiamata 2 volte al click su un colore, avevo pensato di metterla dentro l'if della riga 464 per evitare doppio caricamento
          //questa funzione  viene chiamata sempre anche quando si apre una quickview, ho cercato di bloccarla così $('.quick-view-modal.modal.reveal.large .modal-content.modal-body').children().length
          if(completeYourLookWrapper.length > 0 && $('.quick-view-modal.modal.reveal.large .modal-content.modal-body').children().length === 0){
            updateCompleteYourLook(data)
          }
        }
        $('body').trigger('product:afterAttributeSelect', {
          data: data,
          container: $productContainer
        });

        if (data.product.oosProduct) {
          $('button.add-to-cart', $productContainer).addClass('hidden');
          $('.availability-msg.oos', $productContainer).css({ 'font-size': '18px', 'font-weight': '500', color: '#C82828', 'text-transform': 'uppercase' });
          $('.availability-msg.oos', $productContainer).text(data.product.oosLabel);
          $('.availability-msg.oos', $productContainer).removeClass('hidden');
        } else {
          $('button.add-to-cart', $productContainer).removeClass('hidden');
          $('.availability-msg.oos', $productContainer).addClass('hidden');
        }
      },
      error: function () {
        console.log('error in process the request');
      }
    });
  }
}

function updateScalapayWidget(product){
  if(!product) return;

  const scalapayWidget = $('scalapay-widget');
  try{
    if(scalapayWidget.length && !!product.price.sales.decimalPrice){
      scalapayWidget.attr('amount', product.price.sales.decimalPrice);
    }
  }catch(ex){}
}

function replaceProductsetWidget(data) {
  if (typeof productSetWidgetAction === 'undefined' || typeof data === 'undefined') {
    return;
  }

  if (typeof data.product.productSets !== 'undefined' && data.product.productSets.length > 0) {
    $.ajax({
      url: productSetWidgetAction,
      type: 'GET',
      dataType: 'html',
      data: data.queryString,
      success: function (data) {
        if ($('.extra-product-container').length > 0) {
          if ($('.extra-product-container .product-set').length > 0) {
            $('.extra-product-container .product-set').remove();
          }

          $('.extra-product-container').prepend(data);
          $(document).foundation();
        }
      }
    });
  } else if ($('.extra-product-container .product-set').length > 0) {
    $('.extra-product-container .product-set').remove();
  }
}

/**
 * get template for replace all PDP images
 */
function replaceImages(url, $productContainer) {
  var productContainerImages = $productContainer;
  var carouselImages = null;
  if (productContainerImages.find('.slides').length) {
    carouselImages = productContainerImages.find('.slides');
  }
  if (url) {
    $.ajax({
      url: url,
      method: 'GET',
      beforeSend: function () {
        productContainerImages.addClass('loading');
      },
      success: function (data) {
        productContainerImages.empty().html(data);
        productContainerImages.removeClass('loading');
        if (carouselImages) {
          carouselImages.owlCarousel('destroy');
          carousel.quickviewCarousel();
        } else {
          productContainerImages.owlCarousel('destroy');
          owl(productContainerImages);
        }
      },
      error: function () {
        console.log('error in process the request');
      }
    });
  }
}

/**
 * get template for replace all PDP modal images
 */
function replaceModalImages(url) {
  var productModalImages = $(document).find('.product-zoom-modal');
  if (url) {
    $.ajax({
      url: url,
      method: 'GET',
      success: function (data) {
        productModalImages.empty().html(data);
      },
      error: function () {
        console.log('error in process the request');
      }
    });
  }
}

/**
 * function to update price for SEO event addToCart
 */
function updateAddToCartEvent(product) {
  $(document).ready(function () {
    if (typeof $(document).find('.add-to-cart').data('analiticsp') !== 'undefined') {
      let price = 0;
      if (Object.prototype.hasOwnProperty.call(product.price, 'min')) {
        price = product.price.min;
      } else if (Object.prototype.hasOwnProperty.call(product.price, 'max')) {
        price = product.price.max;
      } else if (Object.prototype.hasOwnProperty.call(product.price, 'sales')) {
        price = product.price.sales.value;
      } else price = product.price;

      let addToCartEvent = $(document).find('.add-to-cart').data('analiticsp');
      let addToCartEventParse = JSON.parse(decodeURIComponent(addToCartEvent));

      let datalayerEvent = {
        name: addToCartEventParse.name,
        id: addToCartEventParse.id,
        price: price,
        brand: 'twinset milano',
        category: addToCartEventParse.category,
        variant: addToCartEventParse.variant,
        quantity: '1',
        dimension14: addToCartEventParse.dimension14,
        dimension15: addToCartEventParse.dimension15,
        dimension16: addToCartEventParse.dimension16
      };

      let encodedDatalayerEvent = encodeURIComponent(JSON.stringify(datalayerEvent));

      let elem = $(document).find('.add-to-cart').not('.add-to-wish-list');
      elem.data('analiticsp', encodedDatalayerEvent);
    }
  });
}


function updateLabel(product){
  if(product.label){
    $('.product-tag-label').text(product.label);
  }
}

function updateCompleteYourLook(data){
  $.ajax({
    url: data.completeYourLook,
    method: 'GET',
    data: { pid: data.product.id },
    success: function(response) {
      $('.complete-your-look-wrapper').html(response);
    },
    error: function(xhr, status, error) {
      console.error('Errore nel caricamento del widget "Complete Your Look":', error);
    }
  });
}
/**
 * get template for replace accordion PDP
 */
function replaceAccordion(url) {
  var productAccordion = $(document).find('.product-accordion');
  if (url) {
    $.ajax({
      url: url,
      method: 'GET',
      success: function (data) {
        productAccordion.empty().html(data);
      },
      complete: function (data) {
        Accordion.run();
      },
      error: function () {
        console.log('error in process the request');
      }
    });
  }
}

/**
 * updates the product view when a "mini product set" attribute is selected or deselected or when changing size
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 */
function attributeSelectMiniSet(selectedValueUrl, $productContainer) {
  if (selectedValueUrl) {
    $.ajax({
      url: selectedValueUrl,
      method: 'GET',
      beforeSend: function () {
        $productContainer.addClass('loading');
      },
      success: function (data) {
        handleVariantMiniSetResponse(data, $productContainer);
        controlSizeModalProductSet();

        // changhe set mini product set PID
        $('body').trigger('product:afterMiniAttributeSelect', {
          data: data,
          container: $productContainer
        });
      },
      error: function () {
        console.log('error in process the request');
      }
    });
  }
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @return {string} - The provided URL to use when adding a product to the cart
 */
function getAddToCartUrl() {
  return $('.add-to-cart-url').val();
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
  var $html = $('<div>').append($.parseHTML(html));

  var body = $html.find('.choice-of-bonus-product');
  var footer = $html.find('.modal-footer').children();

  return {
    body: body,
    footer: footer
  };
}

/**
 * Assignment of post Ajax parameters to open the "size modal" in case the user does not select a size.
 * @param {Object} html - the element to be assigned the parameters to open the "size modal"
 */
function controlSizeModalProduct(elem, response) {
  elem = (!elem) ? $('button.add-to-cart') : $(elem);

  if(!!response && response.hasGiftCard){
    Callout.error(null, response.giftCardAllert, $('#quickViewModal .error-wrapper'), false, false, false);
  }else if ($('[data-attr="size"] .selected').length === 0) {
    if ($('.size-modal').length === 0) {
      elem.removeClass('disabled');
      elem.addClass('no-modal-no-size-selected');
    } else {
      elem.each(function (index, el) {
        if ($(el).parent().is('.cart-and-ipay')) {
          $(el).removeAttr('disabled').attr('data-open', 'size-modal').addClass('disabled');
        } else {
          $(el).removeAttr('disabled').addClass('disabled');
        }
      });
    }
  } else {
    elem.removeAttr('data-open').removeClass('disabled no-size-selected').removeClass('no-modal-no-size-selected');
    elem.removeAttr('disabled');
  }
}

/**
 * Assignment of post Ajax parameters to open the "size modal" in case the user does not select a size.
 * dedicated to products of type product-set
 * @param {Object} html - the element to be assigned the parameters to open the "size modal"
 */
function controlSizeModalProductSet(elem) {
  elem = (!elem) ? $('button.add-to-cart-set') : $(elem);

  elem.each(function (index, el) {
    var elemSelect = $(el).parents('[data-attr="size"]').find('select');
    var elemModalId = $(el).parents('[data-attr="size"]').data('modal');

    if (elemSelect.length > 0) {
      if (typeof elemSelect.find(':selected').data('attr-value') !== 'undefined') {
        $(el).removeAttr('data-open');
      } else if ($('#' + elemModalId).length > 0) {
        $(el).attr('data-open', elemModalId);
      }
    }
  });
}

/**
 * Retrieves the bundle product item ID's for the Controller to replace bundle master product
 * items with their selected variants
 *
 * @return {string[]} - List of selected bundle product item ID's
 */
function getChildProducts() {
  var childProducts = [];
  $('.bundle-item').each(function () {
    childProducts.push({
      pid: $(this).find('.product-id').text(),
      quantity: parseInt($(this).find('label.quantity').data('quantity'), 10)
    });
  });

  return childProducts.length ? JSON.stringify(childProducts) : [];
}

/**
 * Initialize "images grid" carousel on mobile breakpoint
 *
 * @param {jQuery} $el - DOM element for initialize the carousel
 */
function owl($el) {
  const breakpoint = 720;
  let width = $(window).innerWidth();
  let $render = $el;

  if (width > breakpoint) {
    if (!$render.hasClass('owl-carousel') || !$render.length) {
      return;
    }

    $render.removeClass('owl-carousel').trigger('destroy.owl.carousel');
  } else if (width <= breakpoint) {
    if ($render.hasClass('owl-loaded') || !$render.length) {
      return;
    }

    $render.addClass('owl-carousel').owlCarousel({
      items: 1,
      loop: true,
      nav: false,
      dots: true,
      smartSpeed: 450,
      slideTransition: 'ease-in-out'
    });
  }
}

class product {
  constructor() {
    this.methods = {
      editBonusProducts: function (data) {
        // chooseBonusProducts(data);
      }
    };
  }

  colorValue() {
    updateColorName();
  }

  colorAttributeNoClick(element, forceSelect) {
    var oldColor = $('a.swatch-color.selected').data('familyColorSearch');
    var self = $(element);

    if (!forceSelect && (self.attr('disabled') || self.hasClass('unselectable') || self.hasClass('selected'))) {
      return;
    }

    try {
      document.title = document.title.replace(oldColor, self.data('familyColorSearch'));
      var description = $('meta[name="description"]').attr('content');
      var ogDescription = $('meta[property="og:description"]').attr('content');
      $('meta[name="description"]').attr('content', description.replace(oldColor, self.data('familyColorSearch')));
      $('meta[property="og:description"]').attr('content', ogDescription.replace(oldColor, self.data('familyColorSearch')));
    } catch (error) {

    }

    var $productContainer = self.closest('.product-quickview');

    if (!$productContainer.length) {
      $productContainer = self.closest('.product-detail');
      attributeSelect(self.attr('href'), $productContainer);
      attributeSelect(self.attr('href'), $('.size-modal'), true);
      replaceImages(self.data('image-url'), $productContainer.find('.grid-render'));
      replaceModalImages(self.data('modal-image-url'));
      replaceAccordion(self.data('accordion-url'));
      EnhancedSeo.clickAccordion(['.product-accordion .trigger', 'aria-expanded']);
    } else {
      attributeSelect(self.attr('href'), $productContainer);
      replaceImages(self.data('image-url') + '&quickview=true', $productContainer.find('.quick-view-images'));
    }
  }

  colorAttribute() {
    $(document).off('click', '[data-attr="color"] a').on('click', '[data-attr="color"] a', function (e) {
      e.preventDefault();
      this.colorAttributeNoClick(e.currentTarget);
      // check if the event is user generated or programmatically triggered
      var isUserEvent = true;
      if (typeof e.isTrusted !== 'undefined') {
        isUserEvent = e.isTrusted;
      } else if (e.clientX === 0 && e.clientY === 0) {
        // compatibility for browser that does not yet support isTrusted property
        isUserEvent = false;
      }
      // do not trigger variant event if the click is not user generated
      if (isUserEvent) {
        EnhancedSeo.selectedVariant($(e.currentTarget), ['.product-detail', 'pid', 'data-family-color-search']);
      }
    }.bind(this));

    $(document).ready(function () {
      if (colorValueHtmlHead) {
        $('a.swatch-color').each(function (i, el) {
          var colorIndex = $(el).data('familyColorSearch');
          if (colorIndex !== colorValueHtmlHead) {
            try {
              document.title = document.title.replace(colorIndex, colorValueHtmlHead);
              var description = $('meta[name="description"]').attr('content');
              var ogDescription = $('meta[property="og:description"]').attr('content');
              $('meta[name="description"]').attr('content', description.replace(colorIndex, colorValueHtmlHead));
              $('meta[property="og:description"]').attr('content', ogDescription.replace(colorIndex, colorValueHtmlHead));
            } catch (error) {

            }
          }
        });
      }
    });
  }

  selectAttributeNoClick(element) {
    var self = $(element);

    if (self.attr('disabled') || self.hasClass('selected')) {
      return;
    }

    var $productContainer = self.closest('.product-quickview');

    if (!$productContainer.length) {
      $productContainer = $('.product-detail');
      attributeSelect(self.attr('data-url-value'), $productContainer);
      attributeSelect(self.attr('data-url-value'), $('.size-modal'), true);
      replaceAccordion(self[0].dataset.accordionUrl);
    } else {
      attributeSelect(self.attr('data-url-value'), $productContainer);
    }
  }

  selectAttribute() {
    $(document).on('click', '[data-attr="size"] .list-size > li, .options-select', function (e) {
      e.preventDefault();
      this.selectAttributeNoClick(e.currentTarget);
    }.bind(this));

    $(document).on('click', '[data-productset-attr="size"] .list-size > li', function (e) {
      e.preventDefault();
      var self = $(e.currentTarget);
      var referencedSelect = $('[data-modal="' + self.parents('section').attr('id') + '"]').find('select');

      if (self.attr('disabled') || self.hasClass('selected')) {
        return;
      }

      referencedSelect.val(self.attr('data-url-value')).trigger('change');
      var $productContainer = $('[data-modal="' + self.parents('section').attr('id') + '"]');
      attributeSelectMiniSet(self.attr('data-url-value'), $productContainer);
      attributeSelectMiniSet(self.attr('data-url-value'), self.parents('section'), true);
    });
  }

  selectMiniSetAttribute() {
    $(document).on('change', '.set-items-render .list-size', function (e) {
      e.preventDefault();

      const self = $(e.currentTarget);
      const $productContainer = self.closest('.set-items-render');
      let url = self.val();

      if (url === 'null' || url === '') {
        self.closest('.set-items-render').find('.add-to-cart-set').addClass('disabled');
      } else {
        attributeSelectMiniSet(url, $productContainer);
      }
    });
  }

  availability() {
    $(document).on('change', '.quantity-select', function (e) {
      e.preventDefault();

      var $productContainer = $(e.currentTarget).closest('.product-detail');
      if (!$productContainer.length) {
        $productContainer = $(e.currentTarget).closest('.modal-content').find('.product-quickview');
      }

      if ($('.bundle-items', $productContainer).length === 0) {
        attributeSelect($(e.currentTarget).find('option:selected').data('url'), $productContainer);
      }
    });
  }

  addToCart() {
    $(document).off('click', 'button.add-to-cart, button.add-to-cart-global')
      .on('click', 'button.add-to-cart, button.add-to-cart-global', (e, options) => {
        e.preventDefault();

        var addToCartUrl;
        var pid;
        var quantity;
        var pidsObj;
        var options = !!options ? JSON.stringify(options) : null;
        var self = $(e.currentTarget);

        if ((self.hasClass('disabled') && self.hasClass('no-size-selected')) || self.hasClass('no-modal-no-size-selected')) {
          if ($('.list-size').next('.error-msg').length === 0) {
            const div = $('<div class="error-msg"></div>');
            const errorMsg = $('.variation-attr').attr('data-error-msg');
            div.text(errorMsg).insertAfter('.quick-view-details .list-size');
          }

          return;
        }

        pid = getPidValue(self);

        if (self.hasClass('disabled') || self.hasClass('not-enabled-to-add') || self.hasClass('no-modal-no-size-selected')) {
          if (self.hasClass('add-to-wish-list')) {
            EnhancedSeo.noSizeWishlistClick(pid, ['.swatch-color.selected', 'familyColorSearch']);
          } else {
            EnhancedSeo.noSizeClick(pid, ['.swatch-color.selected', 'familyColorSearch']);
          }
          return;
        }

        addToCartUrl = getAddToCartUrl();
        quantity = getQuantitySelected(self) || 1;

        var form = {
          pid: pid,
          pidsObj: pidsObj,
          childProducts: getChildProducts(),
          quantity: quantity,
          options: options
        };

        if (!self.parents('.size-modal').length) {
          controlSizeModalProduct(e.currentTarget);
        } else {
          $('.size-modal .close-modal').trigger('click');
        }

        if (addToCartUrl) {
          $.ajax({
            url: addToCartUrl,
            method: 'POST',
            data: form,
            success: (data) => {
              if(data.error && data.hasGiftCardError){
                showAlertModal(data);
                return;
              }
              if (data.excess || data.error) {
                $('.mini-cart-link').attr('data-has-error', 'true');
              } else {
                $('.mini-cart-link').removeAttr('data-has-error');
              }

              // Trigger Goal Event: cart_created
              if (data.created) {
                dataLayer.push({
                  gaHitType: 'event',
                  event: 'goal_event',
                  event_category: 'cart_created',
                  event_action: pid.replace(/_/g, '|')
                });
              }
              if (pageTypeForJS === 'cart') {
                location.reload();
                $(document).ready(function () {
                  $(this).scrollTop(0);
                });
              }
              AddToCartMsg.handlePostCartAdd(data);
              EnhancedSeo.pushATC(
                self.data("analiticsp"),
                this.getDataLayerGA4(data.cart, pid, "add_to_cart", true)
              );
              $('body').trigger('product:afterAddToCart', data);
            },
            error: function () {
              console.log('error in process request');
            }
          });
        }
      });
  }

  addToCartMiniSet() {
    $(document).on('click', 'button.add-to-cart-set', function (e) {
      e.preventDefault();

      var addToCartUrl;
      var pid;
      var pidsObj;
      var self = $(e.currentTarget);
      var $productContainer = self.closest('.set-item');

      if (self.hasClass('disabled')) {
        return;
      }

      if (!self.parents('.size-modal').length) {
        controlSizeModalProductSet(e.currentTarget);
      } else {
        $('.size-modal .close-modal').trigger('click');
      }

      $('body').trigger('product:beforeAddToCart', this);
      pid = $productContainer.attr('data-pid');
      addToCartUrl = getAddToCartUrl();

      var form = {
        pid: pid,
        pidsObj: pidsObj,
        childProducts: [],
        quantity: 1
      };

      if (addToCartUrl && !self.hasClass('disabled')) {
        $.ajax({
          url: addToCartUrl,
          method: 'POST',
          data: form,
          success: (data) => {
            AddToCartMsg.handlePostCartAdd(data);
            $('body').trigger('product:afterAddToCart', data);

            if (typeof dataLayer !== 'undefined') {
              dataLayer.push({
                event: 'shop_by_look_add_to_cart',
                ecommerce: this.getDataLayerGA4(data.cart, pid, "add_to_cart", false)
              });
            }
          },
          error: function () {
            console.log('error in process request');
          }
        });
      }
    }.bind(this));
  }

  gridImagesCarousel() {
    const win = $(window);
    const gridImages = $('.grid-render');

    let scrollToSlider = function () {
      var breakpoint = Foundation.MediaQuery.current;
      var edge = $('.header-banner').outerHeight(true) + $('header').outerHeight(true);

      if (window.device && (window.device.type === 'mobile' || window.device.type === 'tablet') || breakpoint === 'medium' || breakpoint === 'small') {
        if ($(window).scrollTop() <= edge) {
          $('html, body').animate({
            scrollTop: edge + 10
          }, 500);
        }
      }
    };

    $(document).ready(owl(gridImages));

    win.on('resize', function () {
      owl(gridImages);
    });

    win.on('load', function () {
      scrollToSlider();
    });
  }

  selectBonusProduct() {
    $(document).on('click', '.select-bonus-product', function () {
      var $choiceOfBonusProduct = $(this).parents('.choice-of-bonus-product');
      var pid = $(this).data('pid');
      var maxPids = $('.choose-bonus-product-dialog').data('total-qty');
      var submittedQty = parseInt($(this).parents('.choice-of-bonus-product').find('.bonus-quantity-select').val(), 10);
      var totalQty = 0;
      $.each($('#chooseBonusProductModal .selected-bonus-products .selected-pid'), function () {
        totalQty += $(this).data('qty');
      });
      totalQty += submittedQty;
      var optionID = $(this).parents('.choice-of-bonus-product').find('.product-option').data('option-id');
      var valueId = $(this).parents('.choice-of-bonus-product').find('.options-select option:selected').data('valueId');
      if (totalQty <= maxPids) {
        var selectedBonusProductHtml = ''
            + '<div class="selected-pid row" '
            + 'data-pid="' + pid + '"'
            + 'data-qty="' + submittedQty + '"'
            + 'data-optionID="' + (optionID || '') + '"'
            + 'data-option-selected-value="' + (valueId || '') + '"'
            + '>'
            + '<div class="col-sm-11 col-9 bonus-product-name" >'
            + $choiceOfBonusProduct.find('.product-name').html()
            + '</div>'
            + '<div class="col-1"><i class="fa fa-times" aria-hidden="true"></i></div>'
            + '</div>';
        $('#chooseBonusProductModal .selected-bonus-products').append(selectedBonusProductHtml);
        $('.pre-cart-products').html(totalQty);
        $('.selected-bonus-products .bonus-summary').removeClass('alert-danger');
      } else {
        $('.selected-bonus-products .bonus-summary').addClass('alert-danger');
      }
    });
  }

  removeBonusProduct() {
    $(document).on('click', '.selected-pid', function () {
      $(this).remove();
      var $selected = $('#chooseBonusProductModal .selected-bonus-products .selected-pid');
      var count = 0;
      if ($selected.length) {
        $selected.each(function () {
          count += parseInt($(this).data('qty'), 10);
        });
      }

      $('.pre-cart-products').html(count);
      $('.selected-bonus-products .bonus-summary').removeClass('alert-danger');
    });
  }

  enableBonusProductSelection() {
    $('body').on('bonusproduct:updateSelectButton', function (e, response) {
      $('button.select-bonus-product', response.$productContainer).attr('disabled',
        (!response.product.readyToOrder || !response.product.available));
      var pid = response.product.id;
      $('button.select-bonus-product').data('pid', pid);
    });
  }

  showMoreBonusProducts() {
    $(document).on('click', '.show-more-bonus-products', function () {
      var url = $(this).data('url');
      $('.modal-content').spinner().start();
      $.ajax({
        url: url,
        method: 'GET',
        success: function (html) {
          var parsedHtml = parseHtml(html);
          $('.modal-body').append(parsedHtml.body);
          $('.show-more-bonus-products:first').remove();
          $('.modal-content').spinner().stop();
        },
        error: function () {
          $('.modal-content').spinner().stop();
        }
      });
    });
  }

  /**
   * @param {Object} cart - Cart/Basket Model
   * @param {String|Object} product - ID of product or Product Model
   * @param {String} event - GA4 Event
   * @param {boolean} isSingleQnt - true if the request come from the UpdateQuantity Route
   */
  getDataLayerGA4(cart, product, event, isSingleQnt) {
    var item = (typeof product === "object") ? this.getProductGA4Model(product)
        : cart.items.filter((el) => { return el.id === product; }).map((prod) => this.getProductGA4Model(prod, isSingleQnt));

    var priceValue = item.price ? (Number(item.price) * item.quantity) : (Number(item[0].price) * item[0].quantity);

    return {
      currency: currentCurrency,
      value: priceValue,
      items: event === "remove_from_cart" ?  (Array.isArray(item) ? item : [item])  :  item,
    }
  }

  getCartGA4Model(cart, event, isSingleQnt){

    var items = [];

    for(let i = 0; i < cart.items.length; i++){
      var item = this.getProductGA4Model(cart.items[i], isSingleQnt);
      items.push(item);
    }
    document.dispatchEvent(new Event('cart:update'));

    var priceValue = Number(cart.totals.grandTotal.replace(' ', '').replace(',', '').substring(1));
    if(currentCurrency === "PLN"){
      priceValue = Number(cart.totals.grandTotal.split(' ')[1].replace(/\./g, '').replace(',', '.'));
    }

    return {
      currency: currentCurrency,
      value: priceValue,
      items: items,
    }

  }

  getProductGA4Model(product, isSingleQnt) {
    try{
      const categories = product.categoryPath.split("/");
      const discount = (product.price.list !== null && product.price.sales !== null)
        ? Number((parseFloat(product.price.list.decimalPrice) - parseFloat(product.price.sales.decimalPrice)).toFixed(2)) : 0;
      const color = product.variationAttributes.filter((el) => { return el.id === "color"} )[0];
      const size = product.variationAttributes.filter((el) => { return el.id === "size"} )[0];

      return {
        item_id: product.masterid,
        item_name: product.productName,
        currency: currentCurrency,
        discount: discount,
        item_brand: 'twinset milano',
        item_category: categories.length > 0 ? categories[0] : '',
        item_category2: categories.length > 1 ? categories[1] : '',
        item_category3: categories.length > 2 ? categories[2] : '',
        item_list_name: 'cart',
        item_variant: color.displayValue,
        price: product.price.list
            ? parseFloat((Number(product.price.list.value) - discount).toFixed(2))
            : parseFloat((Number(product.price.sales.value) - discount).toFixed(2)),
        quantity: isSingleQnt ? '1' : product.quantity,
        item_availability: product.availability.inStock ? 'in_stock' : 'out_of_stock',
        item_discount_tag: discount !== 0 ? 'on_sale' : 'not_on_sale',
        available_size_percentage: product.available_size_percentage,
        item_size: size.displayValue,
        item_variant_v2: product.id,
        item_url: product.masterUrl,
        item_img: product.defaultColorImageObj ? product.defaultColorImageObj.large[0].url : product.images.large[0].url
      }
    }catch(ex){
      return {};
    }
  }

  addToCartMobileSEO() {
    $(document).on('click', '.add-to-cart-messages', function () {
      dataLayer.push({
        event: 'asyncAction',
        gaHitType: 'event',
        event_category: 'funzionalita_cross',
        event_action: 'prodotto_aggiunto_al_carrello'
      });
    });

    $(document).on('click', '#mobile-checkout', function () {
      dataLayer.push({
        event: 'asyncAction',
        gaHitType: 'event',
        event_category: 'funzionalita_cross',
        event_action: 'prodotto_aggiunto_al_carrello_new',
        event_label: 'procedi_all_acquisto'
      });
    });

    $(document).on('click', '#mobile-view-cart', function () {
      dataLayer.push({
        event: 'asyncAction',
        gaHitType: 'event',
        event_category: 'funzionalita_cross',
        event_action: 'prodotto_aggiunto_al_carrello_new',
        event_label: 'mostra_carrello'
      });
    });
  }

  addBonusProductsToCart() {
    $(document).on('click', '.add-bonus-products', function () {
      var $readyToOrderBonusProducts = $('.choose-bonus-product-dialog .selected-pid');
      var queryString = '?pids=';
      var url = $('.choose-bonus-product-dialog').data('addtocarturl');
      var pidsObject = {
        bonusProducts: []
      };

      $.each($readyToOrderBonusProducts, function () {
        var qtyOption = parseInt($(this)
          .data('qty'), 10);

        var option = null;
        if (qtyOption > 0) {
          if ($(this).data('optionid') && $(this).data('option-selected-value')) {
            option = {};
            option.optionId = $(this).data('optionid');
            option.productId = $(this).data('pid');
            option.selectedValueId = $(this).data('option-selected-value');
          }
          pidsObject.bonusProducts.push({
            pid: $(this).data('pid'),
            qty: qtyOption,
            options: [option]
          });
          pidsObject.totalQty = parseInt($('.pre-cart-products').html(), 10);
        }
      });
      queryString += JSON.stringify(pidsObject);
      queryString = queryString + '&uuid=' + $('.choose-bonus-product-dialog').data('uuid');
      queryString = queryString + '&pliuuid=' + $('.choose-bonus-product-dialog').data('pliuuid');
      $.spinner().start();
      $.ajax({
        url: url + queryString,
        method: 'POST',
        success: function (data) {
          $.spinner().stop();
          if (data.error) {
            $('.error-choice-of-bonus-products').html(data.errorMessage);
          } else {
            $('.configure-bonus-product-attributes').html(data);
            $('.bonus-products-step2').removeClass('hidden-xl-down');
            $('#chooseBonusProductModal').modal('hide');

            if ($('.add-to-cart-messages').length === 0) {
              $('body').append(
                '<div class="add-to-cart-messages"></div>'
              );
            }
            $('.minicart-quantity').html(data.totalQty);
            $('.add-to-cart-messages').append(
              '<div class="alert alert-success add-to-basket-alert text-center"'
                + ' role="alert">'
                + data.msgSuccess + '</div>'
            );
            setTimeout(function () {
              $('.add-to-basket-alert').remove();
              if ($('.cart-page').length) {
                window.location.reload();
              }
            }, 3000);
          }
        },
        error: function () {
          $.spinner().stop();
        }
      });
    });
  }
}

const Product = new product();
export default Product;



// WEBPACK FOOTER //
// ./assets/scripts/product/index.js